const getters = {
  permissions: ({ permissions }) => permissions,
  myPermissions: ({ myPermissions }) => myPermissions
}

export default getters
